export class InitializeMobileCompanySettingsState {
  static readonly type =
    '[MobleCompanySettings] InitializeMobileCompanySettingsState';
}
